import ScanNewDTO from '@src/adapters/dto/scan/ScanNewDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  hospitalId: string;
}

interface Result {
  scan: ScanNewDTO;
  count: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/scan/new_next',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindScanNextNew = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindScanNextNewLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindScanNextNew;
